// Batch 31 · item 27 (M103) — a "Prepared by / Reviewed by" text field of a form is shown from the form's sign-off bar
// (read-only): the bar is the record of who prepared / reviewed and when. The field is not typed and not counted as an
// answer (backend form_defs.form_completion skips fields marked ``from_signoff_bar`` in the forms library).
import React, { useEffect, useState } from "react";
import api, { ITEM_SAVED_EVENT } from "@/lib/api";
import { fmtDate } from "@/lib/dt";
import { asArray } from "@/lib/asArray";
import { Label } from "@/components/ui/label";

export const SBF_TEXT = {
  en: { none: "Not signed yet", note: "From the sign-off bar" },
  ar: { none: "لم يُوقَّع بعد", note: "من شريط التوقيع" },
};

export function signerText(levels, wanted, lang) {
  const T = SBF_TEXT[lang === "ar" ? "ar" : "en"];
  const parts = asArray(wanted).map((lv) => {
    const row = asArray(levels).find((l) => l.level === lv);
    const s = row && row.signoff;
    return s ? `${s.name || "—"} · ${fmtDate(s.date || s.signed_at) || ""}`.trim() : null;
  }).filter(Boolean);
  return parts.length ? parts.join(" / ") : T.none;
}

export default function SignoffBarField({ engId, formId, field, lang = "en" }) {
  const [levels, setLevels] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get(`/engagements/${engId}/signoffs/item`, { params: { item_type: "form", item_key: formId }, _silent: true })
      .then((r) => { if (alive) setLevels(Array.isArray(r.data?.levels) ? r.data.levels : []); })
      .catch(() => { if (alive) setLevels([]); });
    if (engId && formId) load();
    const evt = ITEM_SAVED_EVENT || "af-item-saved";
    const onSaved = () => load();
    window.addEventListener(evt, onSaved);
    return () => { alive = false; window.removeEventListener(evt, onSaved); };
  }, [engId, formId]);
  const T = SBF_TEXT[lang === "ar" ? "ar" : "en"];
  return (
    <div>
      <Label>{field.label}</Label>
      <div className="min-h-9 rounded border bg-slate-50 px-2 py-1.5 text-sm dark:bg-slate-900" dir="auto" data-testid={`field-${field.id}`}>
        {levels === null ? "…" : signerText(levels, field.from_signoff_bar, lang)}
      </div>
      <div className="mt-0.5 text-[10px] text-muted-foreground" data-testid={`field-${field.id}-from-bar`}>{T.note}</div>
    </div>
  );
}
